{
  "questionnaire": {
    "welcomeIntro": "Ajude-nos a configurar você respondendo a algumas perguntas rápidas",
    "step": "Etapa",
    "steps": "Etapa {{ currentStep }} de {{ totalSteps }}",
    "reason": {
      "question": "Conte-nos o que o trouxe à Iventis hoje?",
      "options": {
        "SitePlanForMyEvent": "Para criar um plano de site para meu evento",
        "TeamPlanMoreEfficiently": "Veja como minha equipe pode planejar com mais eficiência",
        "PlanMultipleEventsPerProject": "Explore como planejar vários eventos ou projetos",
        "JustCurious": "Só por curiosidade"
      }
    },
    "eventType": {
      "question": "E o que você quer planejar?",
      "options": {
        "SportsEvent": "Evento esportivo",
        "RoadEvent": "Evento rodoviário",
        "FestivalOrParade": "Festival ou desfile",
        "ExhibitionOrShow": "Exposições e conferências",
        "MajorEvent": "Evento importante",
        "MultipleEvents": "Vários eventos",
        "Venue": "Um local",
        "SomethingElse": "Outra coisa"
      }
    },
    "experience": {
      "question": "Quanta experiência você tem com ferramentas de planejamento?",
      "options": {
        "HaventUsedBefore": "Eu não usei nenhum antes",
        "Powerpoint": "PowerPoint usado",
        "GoogleEarth": "Aplicativos usados como o Google Earth",
        "GisAndCadSoftware": "Software GIS e CAD usado",
        "Iventis": "Já usei o Iventis antes"
      }
    },
    "projectName": {
      "question": "E finalmente, que nome você tem em mente para o seu projeto hoje?",
      "subLabel": "Dica: esse pode ser o nome do seu evento ou da sua empresa.",
      "options": {
        "projectName": "Nome do projeto"
      },
      "label": "Insira um nome para o seu projeto:"
    },
    "skip": "Ignore por enquanto",
    "ending_screen": {
      "initial_loading": {
        "message": "Estamos apenas configurando as coisas para você",
        "subtext": "Configurando seu projeto e analisando seus requisitos",
        "footerText": "Isso pode levar alguns segundos"
      },
      "taking_longer": {
        "message": "Está demorando um pouco mais do que esperávamos, espere aí!",
        "subtext": "Aperfeiçoando nossas ferramentas para oferecer os resultados mais nítidos",
        "footerText": "Isso pode levar alguns segundos"
      },
      "error": {
        "message": "Opa, algo deu errado.",
        "subtext": "Parece haver um problema do nosso lado.",
        "footer_1": "Por favor",
        "footer_2": "para que possamos ajudá-lo a descobrir o que aconteceu."
      }
    },
    "setup_completed": "Configuração concluída"
  },
  "passwordConditions": {
    "commonPassword": "Senha muito simples. Por favor, tente algo mais complexo."
  },
  "verification": {
    "headings": {
      "checkEmail": "Verifique seu e-mail",
      "emailVerified": "E-mail verificado",
      "alreadyVerified": "Você está pronto para ir"
    },
    "ctas": {
      "continueToLogin": "Continue fazendo login",
      "resendEmail": "Clique para reenviar"
    },
    "noEmail": "Não recebeu o e-mail?",
    "emailSent": "Enviamos um link de verificação para",
    "timerForResend": "em {{ time }} segundos",
    "accountVerifiedMessage": "Sua conta de e-mail foi verificada, clique no botão abaixo para fazer login.",
    "unverifiedErrorMessage": "Não foi possível verificar sua conta de e-mail, entre em contato com nossa equipe de suporte em",
    "alreadyVerifiedMessage": "Essa conta de e-mail já foi verificada. Clique no botão abaixo para fazer o login."
  },
  "createAccount": {
    "free_trial": "Comece o teste gratuito",
    "marketing": "Mantenha-me atualizado com as últimas notícias e atualizações",
    "iventisAccount": "Já tem uma conta Iventis?",
    "error": "Houve um problema ao criar sua conta. Entre em contato",
    "disableAdBlocker": "ou tente desativar seu bloqueador de anúncios e tente novamente."
  },
  "logout": "Sair"
}